import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './accordion.scss';
class Accordion extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);

        let state = {
            isOpen: false,
            itemsOpen: {}
        };

        React.Children.toArray(props.children).forEach((child, index) => {
            if (child) {
                state.itemsOpen[index] = !!child.props.defaultOpen;
            }
        });

        this.state = state;
    }

    componentDidMount() {}

    componentWillUnmount() {}

    handleChange = item => {
        this.setState(prevState => ({
            ...prevState,
            itemsOpen: {
                ...prevState.itemsOpen,
                [item]: !prevState.itemsOpen[item]
            }
        }));
    };

    render() {
        const { children, title } = this.props;
        const newChildren = React.Children.map(children, (child, index) => {
            if (child && child.type !== 'div') {
                return React.cloneElement(child, {
                    isOpen: this.state.itemsOpen[index],
                    handleChange: () => this.handleChange(index)
                });
            }
        });

        return (
            <div className="accordion list-group pr-0">
                {title ? (
                    <div className="d-xs-block d-md-none list-group-item header text-center font-weight-bold">
                        {title}
                    </div>
                ) : null}
                {newChildren}
            </div>
        );
    }
}

Accordion.propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string
};

export default Accordion;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/accordion/accordion.jsx